import * as React from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Title from "./Title";
import { extractUserInfoFromToken, getLocalStorageSAMLToken } from "../utils";
import { accessRequest } from "../redux/dynamo_db/actions";
import { useDispatch } from "react-redux";

export default function Victoria() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const locationObject = {
    materials: "Materials",
    placeholdermaterials: "Placeholder Materials",
    systems: "Systems",
    systemapplications: "System Applications",
    licenses: "Licenses",
    contracts: "Contracts",
    orders: "Orders",
    serialnumbers: "Serial Numbers",
    dataqualitysaporders: "Data Quality Sap Orders",
    hwsprocess: "Hardware Support Process - Asset Data transfer",
    missingsnsstatus: "Missing Serial Numbers Status",
    bulkreport: "Bulk Report",
    upload: "Upload Documents",
    monitoring: "Monitoring",
  };
  const locationHelpText = {
    materials: (
      <div>
        <p>
          This page allows you to search for Materials with different
          filter.{" "}
        </p>
        <p>
          A Material in an asset with a serial number. It can be a DATA or a
          VOICE material if coming from SAP or ARUBA material if coming from
          LDS.
        </p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    contracts: (
      <div>
        <p>This page allows you to search for Contracts. </p>
        <p>
          Contracts can be DATA or VOICE contracts from SAP, or automatic
          contracts created in the datalake. It can also be subscriptions
          contracts from ZUORA.
        </p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    orders: (
      <div>
        <p>This page allows you to search for SAP Orders. </p>
        <p>Those data are RAW data received in the datalake from SAP.</p>
      </div>
    ),
    placeholdermaterials: (
      <div>
        <p>This page allows you to search for Placeholder Materials. </p>
        <p>
          A Placeholder Material was a material that undergo a change of SAP
          order.
        </p>
        <p>
          We keep in this object all the information from before the order
          change and all of the paid contract. We don't keep automatic contracts
          like Standard Hardware Support.
        </p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    systems: (
      <div>
        <p>This page allows you to search for Systems. </p>
        <p>A System is an Asset voice from ELP.</p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    licenses: (
      <div>
        <p>This page allows you to search for Licenses. </p>
        <p>A Licenses is an OV2500 Asset from LDS.</p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    systemapplications: (
      <div>
        <p>This page allows you to search for System Applications. </p>
        <p>A System Application is an opex Asset voice from ELP.</p>
        <p>
          The results in the detail page are elements from aggregated sources.
        </p>
      </div>
    ),
    serialnumbers: (
      <div>
        <p>This page allows you to search for Serial numbers. </p>
        <p>Those data are data received in the datalake from SAP or LDS.</p>
        <p>They are already processed data before asset creation.</p>
      </div>
    ),
    dataqualitysaporders: (
      <div>
        <p>
          This page allows you to search for SAP Order data quality analysis.
        </p>
        <p>
          The elements in this page are SAP Order lines that was analysis in an
          automatic process to determine if there was any missing serial number.
        </p>
        <p>
          All the elements display are lines that was once incomplete in the
          analysis.
        </p>
      </div>
    ),
    hwsprocess: (
      <div>
        <p>
          This page allows you to search for Serial number which went through
          Hardware support process.{" "}
        </p>
        <p>
          The elements display are all serial numbers that was send back to ALE
          with a hardware support Order and process by the datalake.
        </p>
      </div>
    ),
    missingsnsstatus: (
      <div>
        <p>
          This page allows you to search for Serial number which was saw has
          missing at one moment by the datalake.
        </p>
      </div>
    ),
    bulkreport: (
      <div>
        <p>
          This page allows you to see all your bulk upload request and download
          the result.
        </p>
      </div>
    ),
    upload: (
      <div>
        <p>
          This page allows you to upload data for different uses cases directly
          in S3.
        </p>
      </div>
    ),
    monitoring: (
      <div>
        <p>
          This page show the page usage by day/month/lifetime
        </p>
      </div>
    ),
  };

  const handleNavigate = (path) => {
    navigate(`/${path}`);
  };

  const handleRequestAccess = () => {
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    let queryObject = {};
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(accessRequest(queryObject));
  };

  return (
    <React.Fragment>
      <Table size="small" style={{ marginTop: "20px" }}>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold", width: "25%" }}>
              Page Name
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(locationObject).map(([key, label]) => (
            <TableRow
              key={key}
              hover
              onClick={() => handleNavigate(key)}
              style={{ cursor: "pointer" }}
            >
              <TableCell>
                <Typography color="primary" variant="subtitle2">
                  {label}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" component="div">
                  {locationHelpText[key] || "No description available."}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box
        sx={{
          mt: 5,
          p: 3,
          textAlign: "center",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="body1" gutterBottom>
          If you can only access this page, click on the button below and an
          admin will look at the request.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRequestAccess}
          sx={{ mt: 1 }}
        >
          Request Access
        </Button>
      </Box>
    </React.Fragment>
  );
}
